import React, { useEffect } from 'react';

const AUTO_DISMISS_MS = 5000;

const ToastItem = ({ toast, onDismiss }) => {
  useEffect(() => {
    // Errors stay until dismissed so they are not missed.
    if (toast.type === 'error') return undefined;
    const timer = setTimeout(() => onDismiss(toast.id), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [toast.id, toast.type, onDismiss]);

  return (
    <div className={`toast toast-${toast.type}`} role={toast.type === 'error' ? 'alert' : 'status'}>
      <span>{toast.message}</span>
      <button type="button" className="toast-close" onClick={() => onDismiss(toast.id)} aria-label="Dismiss notification">×</button>
    </div>
  );
};

// Brief feedback for completed or failed actions.
export const ToastContainer = ({ toasts, onDismiss }) => (
  <div className="toast-container" aria-live="polite">
    {toasts.map((toast) => (
      <ToastItem key={toast.id} toast={toast} onDismiss={onDismiss} />
    ))}
  </div>
);
